<template>
    <div>
        <PageTitle :title="$t('acreditacion.title')" class="strech"/>
        <FromCreate 
            @submit="crearCreditacion" 
            :acreditacion.sync="acreditacion" 
            :esMovil="esMovil"
            v-if="!terminado"
        />
        <div v-else>
            <section class="padding-vertical-content lightgray-content">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div v-if="!error">
                                <h2>{{ $t('acreditacion.gracias') }}</h2>
                                <p>{{ $t('acreditacion.contacto') }}</p>
                                <Button @click="terminado = false">{{ $t('acreditacion.recargar') }}</Button>
                            </div>
                            <div v-else>
                                <div>
                                    <h2>{{ $t('acreditacion.ups') }}</h2>
                                    <p>{{ $t('acreditacion.error') }}</p>
                                    <Button @click="terminado = false">{{ $t('acreditacion.recargar') }}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import PageTitle from "@/components/frontend/shared/PageTitle";
    import FromCreate from "@/components/frontend/acreditaciones/FormCreate";
    import {useHead} from "@/composables/common/seo/useHead";
    export default {
        name: "Acreditaciones",
        components: {
            PageTitle, FromCreate
        },
        data() {
            return {
                esMovil: false,
                terminado : false,
                error: false,
                acreditacion : {
                    estado: 0,
                    evento_id: '',
                    all_access: false,
                    puertasSelect: [],
                    tipoDocumento: 'DNI'
                },
            };
        },
        created() {
            if(!this.footer.activar_acreditaciones) {
                this.$router.push({ name: 'front.home'});
            }
            useHead('Acreditaciones');
        },
        computed: {
            footer() {
                return this.$store.getters.getFooter;
            },
        },
        methods: {
            crearCreditacion(payload) {
                const params = { ...payload, filters: {} };

                this.$store.dispatch(this.config.getVuexAlias('front.acreditaciones.storage'), params).then(() => {
                    this.terminado = true
                    this.acreditacion = {
                        estado: false,
                        evento_id: '',
                        all_access: false,
                        puertasSelect: [],
                    }
                }).catch(er => {
                    this.error = true
                })
            },
            onResize() {
                this.esMovil = window.innerWidth < 768
            }
        }
    };
</script>